import { fetchAllPlansThunk } from './fetchAllPlansThunk';
export default fetchAllPlansThunk;
